import { ChangeEvent } from "react"
import { Box, Button, Typography } from "@mui/material"

type Props = {
  label: string
  accept: string
  name: string
  onSelect: (file: File | null) => void
  selectedName?: string | null
  existingUrl?: string | null
  testId?: string
}

export default function FileField({ label, accept, name, onSelect, selectedName, existingUrl, testId }: Props) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null
    onSelect(file)
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, my: 2 }}>
      <Typography variant="subtitle2">{label}</Typography>
      <Button variant="outlined" component="label" data-testid={testId ? `${testId}-button` : undefined}>
        Choose file
        <input type="file" hidden accept={accept} name={name} onChange={handleChange}
               data-testid={testId} />
      </Button>
      {selectedName && (
        <Typography variant="body2" data-testid={testId ? `${testId}-selected` : undefined}>
          Selected: {selectedName}
        </Typography>
      )}
      {!selectedName && existingUrl && (
        <Typography variant="body2" color="text.secondary">
          Existing file present
        </Typography>
      )}
    </Box>
  )
}
